import {useActions} from "../../../hook/useActions";
import {useEffect} from "react";
import styles from "./Users.module.scss"
import {useTypedSelector} from "../../../hook/useTypedSelector";
import {useNavigate} from "react-router-dom";
import { useDispatch } from "react-redux";
import type {AppDispatch} from "../../../store/store";
import {useTranslation} from "react-i18next";

const AllUsers = () => {
    const {GetAllUsersAsync, GetAllRolesAsync, DeleteUserAsync, ForceLoginUser} = useActions();
    const {allUsers} = useTypedSelector((store) => store.user);
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();

    useEffect(() => {
        GetAllUsersAsync();
        GetAllRolesAsync();
    }, []);

    if (!allUsers) {
        return <div>Loading...</div>;
    }

    async function handleDeleteClick(userId: string) {
        if (window.confirm("Are you sure you want to delete this user?")) {
                await dispatch(DeleteUserAsync(userId));
                await dispatch(GetAllUsersAsync());
        }
    }

    function handleForceLoginClick(id: string) {
        const data = {id: id};
        ForceLoginUser(data);
        navigate("/redirect");
    }

    return (<div className={styles.container}>
        <h2>User List</h2>
        <button style={{width: "100px"}} onClick={() => navigate("/admin/add-user")}>Add User</button>
        <table className={styles.table}>
            <thead>
            <tr>
                <th>Full Name</th>
                <th>User Name</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Recomendator Number</th>
                <th>Country</th>
                <th>Roles</th>
                <th>Management</th>
            </tr>
            </thead>
            <tbody>
            {allUsers.map((u: any, i :number) => (
                <tr key={i}>
                    <td>{u.fullName}</td>
                    <td>{u.userName}</td>
                    <td>{u.email}</td>
                    <td>{u.phoneNumber}</td>
                    <td>{u.recomendatorNumber}</td>
                    <td>{[u.country, u.city].join(", ")}</td>
                    <td>{u.roles.map((role: string) => t("Roles." + role)).join(", ")}</td>
                    <td>
                        <button className={styles.editButton}
                                onClick={() => navigate("/admin/edit-user?id=" + u.id)}>Edit
                        </button>
                        <button className={styles.deleteButton} onClick={() => {
                            handleDeleteClick(u.id)
                        }}>Delete
                        </button>
                        <button className={styles.editButton} onClick={() => {
                            handleForceLoginClick(u.id);
                        }}>Login
                        </button>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    </div>)
}
export default AllUsers;